/**
 * Aurea Pro — logo immagine (PNG trasparente).
 *
 * Due varianti in /public/brand:
 *  - aurea-logo.png        → "AUREA" nero + "PRO" oro, per sfondi CHIARI
 *  - aurea-logo-white.png  → "AUREA" bianco + "PRO" oro, per sfondi SCURI
 *
 * Scelta automatica: `variant="light"` (hero su foto/scuro) o tema scuro → bianco;
 * altrimenti la versione a colori. Sfondo trasparente, si adatta a tutti i temi.
 *
 * Sizes: sm (sidebar), md (form), lg (hero), xl (loader).
 */
import { useTheme } from "@/context/ThemeContext";

const HEIGHT = {
  sm: "h-9",
  md: "h-12",
  lg: "h-16 lg:h-20",
  xl: "h-20 lg:h-24",
};

const LOGO_DARK = `${process.env.PUBLIC_URL}/brand/aurea-logo.png`;        // su sfondo chiaro
const LOGO_LIGHT = `${process.env.PUBLIC_URL}/brand/aurea-logo-white.png`; // su sfondo scuro

export default function BrandWordmark({ size = "md", variant = "default", showPro, className = "", ...rest }) {
  const { theme } = useTheme();
  const useWhite = variant === "light" || theme === "dark";
  const sizeClass = HEIGHT[size] || HEIGHT.md;
  return (
    <img
      src={useWhite ? LOGO_LIGHT : LOGO_DARK}
      alt="Aurea Pro"
      className={`${sizeClass} w-auto object-contain select-none ${className}`}
      draggable="false"
      data-testid={rest["data-testid"] || "brand-wordmark"}
      {...rest}
    />
  );
}
